/**
 * Handle clicks on anchor links without updating the URL bar
 * Scrolls smoothly to the target element
 */
export default () => {
	document.addEventListener('click', event => {
		const link = event.target.closest('a[href^="#"]');
		if (!link) return;

		const hash = link.getAttribute('href');
		if (!hash || hash === '#') return;

		const targetId = hash.slice(1);
		const target = document.getElementById(targetId);
		if (!target) return;

		event.preventDefault();

		// Account for fixed header
		const header = document.getElementById('header');
		const headerOffset = header ? header.offsetHeight : 0;
		const targetPosition = target.getBoundingClientRect().top + window.scrollY;
		const offsetPosition = targetPosition - headerOffset;

		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth',
		});

		// Optionally focus the target for accessibility
		target.setAttribute('tabindex', '-1');
		target.focus({ preventScroll: true });
	});
};
